import React, { FC } from 'react';
import translation from '../../../../languages';

type VoucherErrorsPropsType = TranslationProps & {
    voucherError: number;
};

const VoucherErrors: FC<VoucherErrorsPropsType> = ({ voucherError, t }) => {
    return (
        <>
            {/* Not enough total to apply voucher */}
            {voucherError === 27 && (
                <p className='text-center voucher-not-applicable'>
                    {t('cart.cartSummary.voucherErrors.notEnoughTotal')}
                </p>
            )}
            {/* Trying to apply author voucher to cart which does not contain his materials */}
            {voucherError === 28 && (
                <p className='text-center voucher-not-applicable'>
                    {t('cart.cartSummary.voucherErrors.notApplicable')}
                </p>
            )}
            {/* Voucher can't be applied because all the materials have fixed price */}
            {voucherError === 31 && (
                <p className='text-center voucher-not-applicable'>{t('cart.cartSummary.voucherErrors.fixedPrice')}</p>
            )}
        </>
    );
};

const translate = translation('cart');

export default translate(VoucherErrors);
